import { render, staticRenderFns } from "./assure-prestations.html?vue&type=template&id=66b579da&scoped=true&external"
import script from "./assure-prestations.js?vue&type=script&lang=js&external"
export * from "./assure-prestations.js?vue&type=script&lang=js&external"
import style0 from "./assure-prestations.scss?vue&type=style&index=0&id=66b579da&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b579da",
  null
  
)

export default component.exports